import { render, staticRenderFns } from "./PaymentLinkDialogForm.vue?vue&type=template&id=13b7f2d4&"
import script from "./PaymentLinkDialogForm.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports